module.exports = __webpack_public_path__ + "img/our-story-expert.00b30788.png";